import { lazy, Suspense } from "react";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import Footer from "@/components/Footer";
import LazySection from "@/components/LazySection";
import SeoHead from "@/components/SeoHead";

const AboutSection = lazy(() => import("@/components/AboutSection"));
const ServicesSection = lazy(() => import("@/components/ServicesSection"));
const TestimonialsSection = lazy(() => import("@/components/TestimonialsSection"));
const CtaBanner = lazy(() => import("@/components/CtaBanner"));
const RealisationsPreview = lazy(() => import("@/components/RealisationsPreview"));
const PartnersSection = lazy(() => import("@/components/PartnersSection"));

const Index = () => (
  <div className="min-h-screen bg-background">
    <SeoHead
      title="HNJR Couverture | Couvreur Yvelines (78) - Devis gratuit"
      description="Couvreur dans les Yvelines (78) : couverture, charpente, zinguerie et isolation. Entreprise familiale, 4 générations, 79 ans d'expérience. Devis gratuit en 24h."
      path="/"
    />
    <Header />
    <main>
      <HeroSection />
      <LazySection>
        <Suspense fallback={null}>
          <RealisationsPreview />
        </Suspense>
      </LazySection>
      <LazySection>
        <Suspense fallback={null}>
          <ServicesSection />
        </Suspense>
      </LazySection>
      <Suspense fallback={null}>
        <AboutSection />
      </Suspense>
      <LazySection>
        <Suspense fallback={null}>
          <PartnersSection />
        </Suspense>
      </LazySection>
      <LazySection>
        <Suspense fallback={null}>
          <TestimonialsSection />
        </Suspense>
      </LazySection>
      <LazySection>
        <Suspense fallback={null}>
          <CtaBanner />
        </Suspense>
      </LazySection>
    </main>
    <Footer />
  </div>
);

export default Index;
